import * as React from "react";
import { useEffect, useState } from "react";

import { Button } from "../Common/Button/Button";

import { JQueryConfirm } from "../../../Common/JQueryConfirm/JQueryConfirm";
import { JQueryConfirmButton } from "../../../Common/JQueryConfirm/JQueryConfirmButton";

import { IEvent } from "../../classes/event";
import { IText } from "../../classes/text";

import * as dates from "../../reducers/changeTimePeriod";

export interface IDeleteEventButtonProps {
  calendarId: number;
  contextId: number;
  currentEvent: IEvent;
  eventId: number;
  isLoading: boolean;
  portletInstanceId: number;
  text: IText;
  onSetEventIdToZero: () => any;
  onSetEventScreenMode: (eventScreenMode: string) => any;
  deleteEventFromService: (portletInstanceId: number, objectId: number, parentId: number, contextId: number, deleteEventType: number, eventInstanceDate: Date) => any;
}

export interface IDeleteEventState {
  displayConfirmDeleteModal_RemoveEvent: boolean;
  displayConfirmDeleteModal_RecurringEvent: boolean;
  displayConfirmDeleteModal_NonrecurringEvent: boolean;
}

export class DeleteEventButton extends React.Component<IDeleteEventButtonProps, IDeleteEventState> {

  public constructor(props: any, context: any) {
    super(props, context);

    this.state = {
      displayConfirmDeleteModal_NonrecurringEvent: false,
      displayConfirmDeleteModal_RecurringEvent: false,
      displayConfirmDeleteModal_RemoveEvent: false,
    };

  }

  public render() {

    const isLoading = this.props.isLoading;
    const event = this.props.currentEvent;
    const intText = this.props.text.eventViews;

    // Delete button text and ID.
    let deleteButtonText = intText.deleteEvent;
    if (event.eventMergeType !== "None" && !event.isTwoWay) { deleteButtonText = intText.removeEvent; }
    const deleteEventButtonID = "deleteEventbutton_" + this.props.portletInstanceId;

    // When user clicks Delete/Remove button, set state so that appropriate modal confirm popup will be displayed.
    const onOpenConfirmDeleteJQueryConfirmModal = (e) => {
      e.preventDefault();

      if (event.eventMergeType !== "None" && !event.isTwoWay) {
        this.setState({ displayConfirmDeleteModal_RemoveEvent: true });
      } else {
        if (event.hasRecurrence) {
          this.setState({ displayConfirmDeleteModal_RecurringEvent: true });
        } else {
          this.setState({ displayConfirmDeleteModal_NonrecurringEvent: true });
        }
      }

    };

    // When user click Remove/Delete button inside the modal confirm popup, delete/remove the event:
    const deleteEvent = (deleteEventType: number) => {
      closeConfirmDeleteJQueryConfirmModal();
      const eventInstanceDate = event.localStartDate;
      this.props.deleteEventFromService(this.props.portletInstanceId, this.props.eventId, event.calendarID, this.props.contextId, deleteEventType, eventInstanceDate);
      this.props.onSetEventScreenMode("LIST");
      this.props.onSetEventIdToZero();
    };

    /// 0 - one occurrence
    /// 1 - Single Event or recurring event
    /// 2 - This and the follwing
    const deleteThisOccurrenceOnly = () => { deleteEvent(0); };

    const deleteSingleEvent = () => { deleteEvent(1); };

    const deleteThisAndFollowing = () => { deleteEvent(2); };

    const deleteAllInstancesOfThisEvent = () => { deleteEvent(1); };

    // When user clicks 'Cancel' button in modal confirm popup, set all modal confirm popups to closed.
    const cancelDeleteEvent = () => { closeConfirmDeleteJQueryConfirmModal(); };

    const closeConfirmDeleteJQueryConfirmModal = () => {
      this.setState({ displayConfirmDeleteModal_RemoveEvent: false, displayConfirmDeleteModal_RecurringEvent: false, displayConfirmDeleteModal_NonrecurringEvent: false });
    };

    // Set the buttons that are displayed inside the JQueryConfirm modals used to confirm delete/remove event:
    const removeEventBtn = new JQueryConfirmButton("remove", intText.remove, "CMS_button CMS_bCancel", deleteThisOccurrenceOnly);
    const deleteAllOccurrencesBtn = new JQueryConfirmButton("deleteOcc", intText.deleteAllOccurrences, "CMS_button CMS_bCancel", deleteAllInstancesOfThisEvent);
    const deleteThisAndFollowingBtn = new JQueryConfirmButton("deleteFoll", intText.deleteThisAndFollowing, "CMS_button CMS_bCancel", deleteThisAndFollowing);
    const deleteOnlyThisOccurrenceBtn = new JQueryConfirmButton("deleteOnl", intText.onlyDeleteThisEvent, "CMS_button CMS_bCancel", deleteThisOccurrenceOnly);
    const deleteNonRecurringEventBtn = new JQueryConfirmButton("delete", intText.delete, "CMS_button CMS_bCancel", deleteSingleEvent);
    const cancelBtn = new JQueryConfirmButton("cancel", intText.cancel, "CMS_button CMS_bAction buttonFocus", cancelDeleteEvent);

    const removeEventbuttons = [removeEventBtn, cancelBtn];
    const recurringEventbuttons = [deleteAllOccurrencesBtn, deleteThisAndFollowingBtn, deleteOnlyThisOccurrenceBtn, cancelBtn];
    const nonrecurringEventbuttons = [deleteNonRecurringEventBtn, cancelBtn];

      return (
        <React.Fragment>
          <Button
            itemID={deleteEventButtonID}
            cssID="CMS_bCancel"
            text={deleteButtonText}
            visibleText={false}
            fontawesomeIconCSS="fa-trash"
            onClick={onOpenConfirmDeleteJQueryConfirmModal}
            disabled={isLoading}
            removeJsNavSystem={true}
            isCMSButton={true}
          />

          <JQueryConfirm
            displayConfirm={this.state.displayConfirmDeleteModal_RemoveEvent}
            title={intText.areYouSureYouWantToRemoveThisEvent}
            content={intText.yourEventWillBePermanentlyRemoved}
            buttons={removeEventbuttons}
          />

          <JQueryConfirm
            displayConfirm={this.state.displayConfirmDeleteModal_RecurringEvent}
            title={intText.thisIsARecurringEvent}
            content={intText.doYouWantToDeleteAllOccurrencesOfTheRecurringEvent}
            buttons={recurringEventbuttons}
          />

          <JQueryConfirm
            displayConfirm={this.state.displayConfirmDeleteModal_NonrecurringEvent}
           title={intText.areYouSureYouWantToDeleteThisEvent}
            content={intText.yourEventWillBePermanentlyDeleted}
            buttons={nonrecurringEventbuttons}
          />
        </React.Fragment>
      );
  }

};
